import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "year-group-list(/:curriculumProgramId)",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-year-group-list" */ "./components"
    ).then(m => m.default)
  ),
  childRoutes: [],
});
